module.exports = {
      id: "yard-cloths-usage",
      viewBox: "0 0 549 352.1",
      url: __webpack_public_path__ + "img/icons.400d09d6.svg#yard-cloths-usage",
      toString: function () {
        return this.url;
      }
    }